import { DriverRate } from "components/shared/driver";
import { OnlineStatus } from "components/shared/user";
import { useUnreadItems } from "contexts/unreadItemsContext";
import { dateTimeToView } from "helpers/date";
import { bidChatDomainTypesEnum, bidChatFlags, bidChatFlagsEnum, chatTypesEnum } from "helpers/enums";
import { hiddenUserData } from "helpers/hiddenData";
import { enumLabel, flagVal, formattedCount } from "helpers/system";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { chatMessagesCount } from "sources/books/chats";

const hasUploadedFileFlagVal = flagVal(bidChatFlags, bidChatFlagsEnum.HasUploadedFile);

const DriverChat = (props) => {
    const { driverChat } = props;
    const { readItems } = useUnreadItems();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!driverChat) {
            return;
        }
        chatMessagesCount(driverChat.id).then(setCount);
    }, [driverChat]);

    if (!driverChat) {
        return null;
    }

    const hasUploadedFile = (driverChat.intChatFlags & hasUploadedFileFlagVal) === hasUploadedFileFlagVal;
    const toChat = (chatId) => {
        props.toChat(chatId);
        if (count > 0) {
            readItems({ chatId, chatType: chatTypesEnum.DriverChat });
            setCount(0);
        }
    };
    return (
        <a className="show-bid__link d-inline-block position-relative" onClick={toChat.bind(this, driverChat.id)}>
            <i className="icon-uEA08-dialog show-bid__driver-chat-icon" />
            &nbsp;Чат
            {!!count && <div className="notifys__count notifys__count--right">{formattedCount(count)}</div>}
            {hasUploadedFile && (
                <Tooltip
                    placement="bottom"
                    overlayClassName="notifys__tooltip"
                    overlay={enumLabel(bidChatFlags, bidChatFlagsEnum.HasUploadedFile)}
                >
                    <i className="icon-uEA0A-file show-bid__driver-chat-icon pl-1" />
                </Tooltip>
            )}
        </a>
    );
};

const Driver = (props) => {
    const { bid, toChat, bidPolicy, organizationTimezone, modal, refreshBidData } = props;
    if (!bidPolicy.canSeeAdditionalInfo()) {
        return null;
    }
    const { driver, chats, acceptedByDriverAt, secondaryDriver, canApplyFeedback, feedback, id, isDriverForwarder } =
        bid;
    if (!driver) {
        return null;
    }

    const driverChat = chats.find((item) => item.type === bidChatDomainTypesEnum.Secondary);

    const renderDriverData = (driver, isSecondary) => {
        const { user, isOnline, lastSignInAt, comment, inn } = driver || {};
        const { firstName, lastName, patronymic, phoneNumber } = user || {};
        const showDriverInfo = () => {
            modal({
                name: "infoModal",
                windowMod: "wide",
                title: "Ссылки на документы водителя",
                body: <div className="modal__body">{comment}</div>,
            });
        };
        return (
            <>
                <div className="show-bid__main-info--title">{isSecondary ? "Второй водитель" : "Водитель"}</div>
                <div
                    className="show-bid__main-info--value"
                    data-test-id={`bid-${isSecondary ? "secondary" : "main"}-driver`}
                >
                    <div className="d-inline-block pr-1">
                        <OnlineStatus
                            short
                            isOnline={isOnline}
                            lastSignInAt={lastSignInAt}
                            organizationTimezone={organizationTimezone}
                        />
                        {[lastName, firstName, patronymic].join(" ")}
                        {comment && (
                            <span className="pl-1 show-bid__link-gray" onClick={showDriverInfo}>
                                <i className="icon-uEA88-info-circle show-bid__driver-chat-icon" />
                            </span>
                        )}
                    </div>
                    {phoneNumber && (
                        <span className="text-muted pr-1">({hiddenUserData(phoneNumber, { type: "phone" })})</span>
                    )}
                    {inn && (
                        <span className="text-muted pr-1">
                            ИННФЛ: {hiddenUserData(inn, { type: "docNumber" })}
                        </span>
                    )}
                    {!isSecondary && isDriverForwarder && (
                        <span className="badge badge-info mr-1" data-test-id="driver-forwarder">
                            Водитель-экспедитор
                        </span>
                    )}
                    {!isSecondary && (
                        <>
                            <DriverChat toChat={toChat} driverChat={driverChat} />
                            <DriverRate
                                canApplyFeedback={canApplyFeedback}
                                feedback={feedback}
                                bidId={id}
                                modal={modal}
                                refreshBidData={refreshBidData}
                            />
                        </>
                    )}
                </div>
            </>
        );
    };
    return (
        <>
            {renderDriverData(driver, false)}
            {acceptedByDriverAt && (
                <>
                    <div className="show-bid__main-info--title">Принята водителем</div>
                    <div className="show-bid__main-info--value" data-test-id="driver-accepted-at">
                        <span>
                            Да ({dateTimeToView(acceptedByDriverAt)} {dateTimeToView(acceptedByDriverAt, "Z")})
                        </span>
                    </div>
                </>
            )}
            {secondaryDriver && renderDriverData(secondaryDriver, true)}
        </>
    );
};

export default Driver;
